<div class="card, footercard">
    <h3 class="footerP">Contact Us</h3>
    <div class="addressMain">
        <div class="address">
            <div class="map">
                <span>
                    <i class="fa fa-map" aria-hidden="true"></i>
                </span>
                <p>{{selectedBranch?.shortAddress}}</p>
            </div>
            <div class="contactInfo">
                <div class="phone">
                    <span>
                        <i class="fa fa-phone" aria-hidden="true"></i>
                    </span>
                    <p>{{selectedBranch?.phone}}</p>
                </div>
                <div class="email">
                    <span>
                        <i class="fa fa-envelope" aria-hidden="true"></i>
                    </span>
                    <p>{{selectedBranch?.contactPersonEmail}}</p>
                </div>
                <div class="url">
                    <span>
                        <i class="fa fa-globe" aria-hidden="true"></i>
                    </span>
                    <a href="http://tecfolk.com/tecgym.html" target="_blank"
                        style="color: #ffb400;margin-left: 5px; font-size: 14px;text-decoration: underline;">Know more about TecGym.</a>
                </div>
            </div>
        </div>
    </div>
</div>
